export default {
  buttons: {
    apply: "Alkalmaz",
    cancel: "TÖRLÉS",
    dismiss: "Bezárás",
    minimize: "kicsinyít",
    unminimize: "visszaállít",
    add_waypoint: "Adjon meg egy célállomást!",
    navigate: "Navigate",
    send_to_phone: "Send to phone"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "mérföld"
    }
  },
  send_to_phone: {
    title: "Send to phone",
    copy_link: {
    header: "Copy this link to share",
    button: "Copy link"
    },
    qr_code_header: "Scan this QR code with your phone",
    mail: {
    link: "Send via email",
    header: "Mail",
      subject: "Shell Site Locator: your route to {destination}",
      body: "{url}"
    }
  },
  search: {
    title: "Keresés",
    placeholder: "Adjon meg egy helyet",
    enter_location: "Adjon meg egy helyet",
    recent_searches: "Legutóbbi keresés",
    suggestions: "Javaslatok",
    geolocation: "Use my location",
    help: {
      inactive: "Keresés",
      clear: "Clear"
    }
  },
  filters: {
    title: "Szűrők",
    more: "Több szűrő",
    less: "Kevesebb szűrő",
    group: {
      more: "Több",
      less: "Kevesebb"
    },
    amenities: {
      title: "Szolgáltatások és kényelem"
    },
    fuels: {
      title: "Üzemanyagtípusok"
    },
    open_statuses: {
      title: "Opening Hours"
    }
  },
  directions: {
    title: "Útvonaltervező",
    help: {
      add_waypoint: "Útvonal hozzáadása",
      reverse: "Ellenkező irányok",
      sort_waypoint: "Kattintson és húzza a kívánt helyre",
      remove: "Az útvonal eltávolítása"
    },
    placeholder: {
      origin: "Válasszon kiindulási pontot",
      destination: "Adjon meg egy helyet",
      waypoint: "Adjon meg egy helyet"
    },
    route: {
      title: "Opciók",
      title_avoid: "Kerülje el",
      avoid_tolls: "Fizetős utak elkerülése",
      avoid_highways: "Autópályák elkerülése",
      avoid_ferries: "Kerülje a kompokat",
      title_corridor: "Az Ön útvonala és a töltőállomások közötti távolság"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# hét} other {# hetek}}
{days, plural, =0 {} =1 {# nap} other {# nap}}
{hours, plural, =0 {} =1 {# óra} other {# órák}}
{minutes, plural, =0 {} =1 {# perc} other {# perc}}
`,
    button: "Keresés",
    error: "Probléma történt az útvonal feldolgozása során. Kérjük próbálja újra."
  },
  action_panel: {
    back_to_results: "Vissza a találatokhoz"
  },
  locations: {
    title: "helyszínek",
    closed_temporarily: "Ideiglenesen zárva",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} innen {place}",
    description: "{visible, select, true {Elrejt} false {Mutat} }"
  },
  open_now: {
    open_until: "OPEN NOW: until {statusChangeTime, date, dateFormat}",
    open_24_hours: "24 órás nyitva tartás",
    closed_until: "CLOSED NOW: open from {statusChangeTime, date, dateFormat}"
  },
  info_window: {
    back_to_results: "Vissza a találatokhoz",
    title: "Töltőállomás adatai",
    location_id: "Állomás szám",
    website: "Weboldal",
    services: "Szolgáltatások és kényelem",
    nearby: "Közelben",
    directions: "Hozzáadás az útvonaltervezőhöz",
    mobile: {
    telephone: "Tel:"
    },
    opening_hours: {
      title: "Nyitvatartási idő",
      mon: "H",
      tue: "K",
      wed: "Sz",
      thu: "CS",
      fri: "P",
      sat: "SZ",
      sun: "V",
      open_twentyfourhours: "24 órás nyitva tartás",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      available: "Üzemanyagár elérhető",
      not_available: "Elérhető üzemanyag",
      price: "{price, number, fuelPrice}",
      disclaimer: "Az információk csak tájékoztató jellegűek, információkat a töltőállomásokon érhetőek el.",
      last_updated_on: "Legutolsó frissítés",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Útvonaltervező"
  },
  fuels: {
    auto_rv_propane: "Auto RV Propane",
    autogas_lpg: "Motoric Gas",
    cng: "CNG",
    diesel_fit: "Diesel Fit",
    fuelsave_98: "Fuelsave 98",
    fuelsave_midgrade_gasoline: "Shell FuelSave Euro 95",
    fuelsave_regular_diesel: "Shell Fuelsave Diesel",
    gtl: "GTL",
    hydrogen: "Hydrogen",
    lng: "LNG",
    low_octane_gasoline: "Regural Benzin",
    midgrade_gasoline: "Premium Benzin",
    premium_diesel: "Shell V-Power Diesel",
    premium_gasoline: "Super Benzin",
    shell_regular_diesel: "Shell Regular Diesel",
    super98: "Super98",
    super_premium_gasoline: "Shell V-Power Racing",
    truck_diesel: "Truck Diesel",
    unleaded_super: "Unleaded Super",
    kerosene: "Kerosene",
    shell_recharge: "Shell Recharge",
  },
  amenities: {
    air_and_water: "Levegő pumpa",
    atm_in: "ATM-IN",
    atm_out: "ATM-OUT",
    atm: "ATM",
    austrian_highway_sticker: "Osztrák autópálya matrica",
    baby_change_facilities: "Baby changing facilites",
    bakery_shop: "Hot Dog",
    bottled_gas: "BBQ Propane Cylinder Exchange",
    burger: "Hamburger",
    cafe: "Kávézó",
    carwash: "Autómosó",
    children_play_area: "Childrens play area",
    childs_toilet: "Water Closet or Toilet - child",
    clubsmart_card: "CLUBSMART kártya elfogadás",
    coca_cola_freestyle: "Coca Cola Freestyle",
    conveyor_and_jet: "Conveyor and Jet",
    conveyor: "Conveyor",
    costa_express: "Costa Express",
    credit_card_american_express: "American Express elfogadás",
    credit_card_diners_club: "Diners Club bankkártya",
    credit_card_general: "Credit card - General",
    credit_card_mastercard: "Mastercard bankkártya",
    credit_card_visa: "Visa bankkártya",
    credit_card: "Bankkártya elfogadás - Visa, Mastercard",
    czech_highway_sticker: "Cseh autópálya matrica",
    deli2go: "Deli2Go termékek",
    disability_assistance: "Disability Assistance",
    disabled_facilities: "Disabled Facilities",
    euroshell_card: "euroShell Card elfogadóhely",
    fleet_card_dkv: "DKW kártya elfogadás",
    fleet_card_eni: "ENI kártya elfogadás",
    fleet_card_esso: "Esso kártya elfogadás",
    fleet_card_general: "Shell Card üzemanyagkártya / euroShell Card üzemanyagkártya",
    fleet_card_uta: "UTA kártya elfogadás",
    food_offerings: "Grillcsirke",
    fuel_card: "Üzemanyagkártya",
    full_service: "Kiszolgálás",
    guarded_car_park: "Őrzött parkoló",
    hgv_lane: "Tehergépjármű-barát",
    high_speed_diesel_pump: "nagynyomású kútfej",
    hot_food: "Meleg ételek",
    hungarian_highway_sticker: "Magyar autópálya matrica",
    ido_ticket: "Ido Ticket",
    jet: "Autómosó",
    lottery: "Lottery",
    loyalty_cards: "CLUBSMART kártya",
    manual: "Kézikönyv",
    maut_terminal: "HU-GO e-útdíj",
    mobile_airtime: "Mobile airtime",
    mobile_loyalty: "Mobile Loyalty",
    mobile_payment: "Mobilfizetés",
    money_transfer_services: "Money transfer services",
    motorway_service: "Autópálya matrica",
    navigator_fleet_loyalty_discount: "ClubSmart kedvezmény",
    oil_and_lubricants: "Oil and lubricants",
    others: "Egyebek",
    parking_lanes: "Parkoló sáv",
    partner_card: "Partner kártya",
    partner_loyalty_accepted: "Partner Loyalty Accepted",
    pay_at_pump: "Fizetés a kútoszlopnál",
    pizza: "Pizza",
    prayer_room: "Prayer room",
    quick_lubes: "Quick-lube",
    restaurant: "Étterem",
    rollover_and_jet: "Rollover and Jet",
    rollover: "Rollover",
    sandwich: "Szendvics",
    sconti_bancoposta: "Sconti BancoPosta",
    selectshop: "Shell Shop",
    self_service: "Önkiszolgáló",
    service_bay: "Service Bays",
    shell_card: "euroShell Card elfogadóhely",
    shell_club_smart_extra_card: "Shell Club Smart Extra Card",
    shop: "Shop",
    shower: "Zuhanyzó",
    slovak_highway_sticker: "Szlovák autópálya matrica",
    snack_food: "Gyors ételek",
    standard_toilet: "Mosdó",
    starbucks: "Starbucks",
    supermarket_fuel_discount: "Üzemanyag kedvezmény",
    telepass_premium: "Telepass Premium",
    tim_hortons: "Tim Horton",
    toilet: "Mosdó",
    truck_parking: "Tehergépjármű parkoló",
    truckport: "Kizárólag tehergépjárművek részére",
    twenty_four_hour: "24 órás nyitva tartás",
    twotheloo: "2theloo mosdó",
    tyre_service: "Tyre service",
    unmanned: "Unmanned",
    utility_payment_services: "Utility payment services",
    vacuum: "Porszívó",
    vehicle_identity_system: "Gépjármű azonosító rendszer",
    waitrose: "Waitrose",
    wifi: "Ingyenes wifi",
    pizza_hut_express: "Pizza Hut Express",
    budgens: "Budgens",
    deli_cafe: "Deli Cafe",
    amazon_locker: "Amazon Locker",
    deli_by_shell: "Deli By Shell",
    car_wash_mpay: "Car Wash MPay",
    pay_tm: "PayTM",
    adblue_truck: "Adblue",
    adblue_car: "AdBlue Pump Passenger Vehicles",
    adblue_pack: "AdBlue Packed Product",
    migrolino: "Migrolino",
    spar_express: "Spar Express"
  },
  open_statuses: {
    open_now: "Open now"
  },
  settings: {
    title: "Beállítások",
    tooltip: "Beállítások",
    traffic: "Forgalom",
    distance_units: {
      title: "Távolság",
      km: "kilométer",
      miles: "mérföld"
    },
    language: {
      title: "Nyelv",
      locales: {
        es_AR: "Spanish",
        en_AU: "English",
        de_AT: "German",
        fr_BE: "French",
        nl_BE: "Dutch",
        pt_BR: "Portugese",
        en_BG: "English",
        bg_BG: "Bulgarian",
        fr_CA: "French",
        en_CA: "English",
        cz_CZ: "Czech",
        da_DK: "Danish",
        fi_FI: "Finnish",
        fr_FR: "French",
        de_DE: "German",
        en_HK: "English",
        zh_HK: "Chinese (traditional)",
        hu_HU: "Hungarian",
        en_IN: "English",
        en_ID: "English",
        id_ID: "Indonesian",
        it_IT: "Italian",
        lv_LV: "Latvian",
        ru_LV: "Russian",
        lt_LT: "Lithuanian",
        fr_LU: "French",
        en_LU: "English",
        en_MY: "English",
        en_MO: "English",
        zh_MO: "Chinese (traditional)",
        es_MX: "Spanish",
        nl_NL: "Dutch",
        nb_NO: "Norwegian (Bokmal)",
        en_OM: "English",
        ar_OM: "Arabic",
        en_PK: "English",
        ur_PK: "Urdu",
        en_PH: "English",
        pl_PL: "Polish",
        es_PR: "Spanish",
        ro_RO: "Romanian",
        ru_RU: "Russian",
        en_SG: "English",
        sk_SK: "Slovak",
        sl_SI: "Slovene",
        en_ZA: "English",
        sv_SE: "Svenska",
        fr_CH: "French",
        de_CH: "German",
        th_TH: "Thai",
        tr_TR: "Turkish",
        uk_UA: "Ukrainian",
        en_GB: "English",
        en_US: "English",
      }
    }
  },
  geolocation: {
    tooltip: "Use my location"
  }
}
